import type ClientItem from '../store/schema/ClientItem';
import mailStore from '../store/Store';

export default function selectMailStoreItemById(itemId: string): ClientItem {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (8,5): Type 'ClientItem | undefined' is not assignable to type 'Item'.
    // @ts-expect-error
    return mailStore().items.get(itemId);
}
